<template>
    <b-card no-body>
        <v-table    ref="table"
                    :fields="c_fields"
                    :items-provider="provider"
                    pagination="server"
                    search
                    :buttons="buttons"
                    name="salary">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="months" label="name" placeholder="Ay" v-model="c_month"></v-select-list>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="years" placeholder="Yıl" v-model="year"></v-select-list>
                                </div>
                                <div class="col-md-2 mb-1 mb-md-0">
                                    <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube (Tümü)"></v-select-list>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success w-100" v-on:click="$refs.table.refresh()">
                                        Sorgula
                                    </button>
                                </div>
                                <!-- <div class="col-md-auto">
                                    <v-executer variant="dark" :action="save" :loading="saving" :text="`Maaşları (${(selectedSalaries || []).length} Personel) Onayla`"></v-executer>
                                </div> -->
                            </div>
                        </template>
                    </v-table>
        
    </b-card>
</template>

<script>
import { BCard, } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import CompanyApi from '@/api/company'

export default {
    components:{
        BCard,
    },
    data(){
        return{
            loading:false,
            tips:[],
            bonusPaymentTypes:[],
            month:Number(moment().month() + 1),
            year: Number(moment().format('YYYY')),
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            saving:false,
            branch:null,
            branches:[],
            buttons:[
                { text:"Maaş Tablosuna Gönder",key:"delete",icon:"XIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    mounted(){
        this.configureYears()
        this.getOtherDatas()
        this.getBranches()
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.SalaryApprovedTable({
                PaginationRequest :data,
                Month:this.month,
                Year:this.year,
                BranchId:this.branch?.Id || null
            })
        },
        getOtherDatas(){
            EmployeeOperationsApi.SalaryScreenData().then(res=>{
                this.tips = res.data.Data.PayrollTips
                this.bonusPaymentTypes = res.data.Data.BonusPaymentTypes
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FullName} adlı personeli maaş tablosuna geri gönderir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.SalaryDeleteApproved({Ids:[item.Id]}).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    },
    computed:{
        c_fields(){
            return [
                {
                    name:'',
                    children:[
                        {name:'Personel',key:'FullName',thClass:'text-nowrap',tdClass:'text-nowrap',sticky:true},
                        {name:'Kimlik Numarası',key:'IdentityNumber',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'IBAN',key:'IBAN',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'SGK Şube',key:'SGKBranch',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Organizasyonel Şube',key:'OrganizationalBranch',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Görev Yeri',key:'GarageName',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Giriş Tarihi',key:'JobStartDate',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Çıkış Tarihi',key:'JobExitDate',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Yıllık İzin',key:'AnnualHoliday',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Ücretli İzin',key:'PaidHoliday',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Diğer Eksik Gün',key:'OtherLackOfDay',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Sabit Maaşı',key:'FixedSalary',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Net Çalışma Günü',key:'NetWorkedDays',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Hak Edilen Sabit Maaş',key:'EarnedFixedSalary',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Yıllık İzin Kazanç',key:'none',thClass:'text-nowrap',tdClass:'text-nowrap'},
                    ]
                },
                {
                    name:'Prim',
                    thClass:'bg-light-warning text-center',
                    children:[
                        ...this.bonusPaymentTypes.map(bt=>({
                            name:bt,
                            key:`BonusPayments.${bt}`,
                            thClass:'bg-light-warning text-nowrap'
                        })),
                    ]
                },
                {
                    name:'',
                    children:[
                        {name:'Toplam Hakediş',key:'none',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Önceki Ay Toplam Hakedis',key:'none',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Kalan Ödeme Rassal Avans',key:'RandomAdvance',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Yıllık İzin Avans',key:'AnnualHolidayAdvance',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Sabit Maaş Avans',key:'FixedSalaryAdvance',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Avans Toplamı',key:'TotalAdvance',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'İcra',key:'Levy',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Bes',key:'BES',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Trafik Ceza',key:'TrafficFine',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Ticket',key:'Ticket',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Tahakkuk Tutarı (T Dahil)',key:'AccrualT',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Tahakkuk Tutarı (T Hariç)',key:'Accrual',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        {name:'Kalan Hakediş',key:'RemainingGain',thClass:'text-nowrap',tdClass:'text-nowrap'},
                        // {name:'TMS Kasa',key:'TMSVault',thClass:'text-nowrap',tdClass:'text-nowrap'},
                    ]
                }
            ]
        },
        c_month:{
            get:function(){
                return this.months.find(s=>s.index==this.month)
            },
            set:function(value){
                this.month = value?.index || null
            }
        }
    }
}
</script>

<style>
.column-sticky{
    position: sticky;
    left: 0px;
    box-shadow: inset -1px 0px 0px 0px #d4d2de;
    z-index: 1;
}

.column-sticky:not(th){
    background-color: white;
}

.dark-layout .column-sticky:not(th){
    background-color: #283046 !important;
}

.dark-layout .column-sticky{
    box-shadow: inset -1px 0px 0px 0px rgb(75, 82, 103);
}
</style>